export const getCookie = (name) => {
  //console.log('getCookie: all cookies:', document.cookie); // Логируем все cookies
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  const value = match ? match[2] : null;
  return value;
};

export const setCookie = (name, value, days = 30) => {
  const expires = new Date(Date.now() + days * 86400000).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`; // Убрали HttpOnly и Secure для теста
};